import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';

const RejectReturnDialog = ({ visible, onHide, action, onConfirm, isLoading = false }) => {
    const { th } = useLanguage();
    const [description, setDescription] = useState('');
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (visible) {
            setDescription('');
            setSubmitted(false);
        }
    }, [visible]);

    const isReject = action === 2;
    const title = isReject
        ? th('vehicleSalesOrderRequests.rejectReturn.rejectTitle')
        : th('vehicleSalesOrderRequests.rejectReturn.returnTitle');

    const handleConfirm = () => {
        setSubmitted(true);
        if (!description.trim()) return;
        onConfirm?.(description.trim());
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('vehicleSalesOrderRequests.buttons.cancel')}
                icon="pi pi-times"
                className="p-button-text"
                onClick={onHide}
                disabled={isLoading}
            />
            <Button
                label={isReject ? th('vehicleSalesOrderRequests.buttons.reject') : th('vehicleSalesOrderRequests.buttons.return')}
                icon={isReject ? 'pi pi-times-circle' : 'pi pi-replay'}
                className={isReject ? 'p-button-danger' : 'p-button-warning'}
                onClick={handleConfirm}
                loading={isLoading}
            />
        </div>
    );

    return (
        <Dialog
            header={title}
            visible={visible}
            onHide={onHide}
            style={{ width: '500px' }}
            footer={footer}
            modal
        >
            <div className="field">
                <label className="font-bold block mb-2">
                    {th('vehicleSalesOrderRequests.rejectReturn.descriptionLabel')} <span className="text-red-500">*</span>
                </label>
                <InputTextarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows={4}
                    className={`w-full ${submitted && !description.trim() ? 'p-invalid' : ''}`}
                    placeholder={th('vehicleSalesOrderRequests.rejectReturn.descriptionPlaceholder')}
                    autoFocus
                />
                {submitted && !description.trim() && (
                    <small className="p-error block mt-1">
                        {th('vehicleSalesOrderRequests.rejectReturn.descriptionRequired')}
                    </small>
                )}
            </div>
        </Dialog>
    );
};

export default RejectReturnDialog;
